module.exports = __webpack_public_path__ + "img/4ae7834.jpg";